/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
import React, { useState, useEffect, useContext } from "react";
import Select, { components } from "react-select";
import { useTranslation } from "react-i18next";

import FiltersContext from "../context/FiltersContext";

import api from "../api/Api";
import Translate from "../i18n/Translate";

import { ScopeIcon, ShortArrow } from "./icons";

const Selects = () => {
  // Estados
  const [data, setData] = useState({
    loading: false,
    data: [],
    error: null,
  });

  const [eventsOptions, setEventsOptions] = useState([]);
  const [countriesOptions, setCountriesOptions] = useState([]);

  const [eventsSelected, setEventsSelected] = useState("");
  const [countrySelected, setCountrySelected] = useState("");

  // Hooks
  const { t } = useTranslation();

  // Contextos
  const { setFilters } = useContext(FiltersContext);

  /* Funciones */
  const getData = async () => {
    setData({
      ...data,
      loading: true,
      error: null,
    });

    try {
      const response = await api.packages.getAll();
      console.log(response, "full response");
      setData({
        data: response.data,
        loading: false,
      });
    } catch (error) {
      setData({
        loading: false,
        error,
      });
      console.log("error");
    }
  };

  const handleSelect = (e, type) => {
    const { value } = e;

    type === "events"
      ? setEventsSelected(value)
      : type === "country"
      ? setCountrySelected(value)
      : null;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setFilters({ event: eventsSelected, country: countrySelected });
  };

  const setValuesFilters = (dataArray) => {
    console.log(dataArray, "dataArray being processed");
    if (dataArray?.length) {
      const newEvents = [];
      const newCountry = [];
      console.log(dataArray, "dataArray");
      dataArray.forEach((item) => {
        console.log(item, "item");
        const event = item.category;
        const country = item.location;

        if (!newEvents.find((option) => option.value === event)) {
          newEvents.push({ value: event, label: event });
          setEventsOptions([...eventsOptions, ...newEvents]);
        }

        if (!newCountry.find((option) => option.value === country)) {
          newCountry.push({ value: country, label: country.replace("-", " ") });
          setCountriesOptions([...countriesOptions, ...newCountry]);
        }
      });
    }
  };

  // Para cambiar el svg del indicador del select
  const IndicatorsContainer = (props) => (
    <components.DropdownIndicator {...props}>
      <ShortArrow width={20} height={20} />
    </components.DropdownIndicator>
  );

  useEffect(() => {
        data.data?.length && setValuesFilters(data.data);
  }, [data]);

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <form className="search" onSubmit={handleSubmit}>
        <div className="search__selects">
          <Select
            options={eventsOptions}
            isSearchable={false}
            className="destination-select"
            classNamePrefix="destination-select"
            placeholder={t("home.hero.selects.event")}
            components={{ IndicatorsContainer }}
            hideSelectedOptions
            onChange={(e) => handleSelect(e, "events")}
          />
          <Select
            options={countriesOptions}
            isSearchable={false}
            className="destination-select"
            classNamePrefix="destination-select"
            placeholder="País"
            components={{ IndicatorsContainer }}
            hideSelectedOptions
            onChange={(e) => handleSelect(e, "country")}
          />
        </div>

        <button
          className="search__button"
          type="submit"
          // disabled={
          //   eventsSelected === "" || countrySelected === "" ? true : false
          // }
          title={
            eventsSelected === "" || countrySelected === ""
              ? "Seleccione un evento o ciudad primero"
              : "Presione para filtrar"
          }
        >
          <ScopeIcon stroke="#fff" />
          <Translate langkey="globals.search" />
        </button>
      </form>
    </>
  );
};

export default Selects;
